export const GET_HOTEL_LIST_REQUEST = "GET_HOTEL_LIST_REQUEST";
export const GET_HOTEL_LIST_SUCCESS = "GET_HOTEL_LIST_SUCCESS";
export const GET_HOTEL_LIST_FAILED = "GET_HOTEL_LIST_FAILED";

export const GET_HOTEL_PROFILE_REQUEST = "GET_HOTEL_PROFILE_REQUEST";
export const GET_HOTEL_PROFILE_SUCCESS = "GET_HOTEL_PROFILE_SUCCESS";
export const GET_HOTEL_PROFILE_FAILED = "GET_HOTEL_PROFILE_FAILED";

export const CREATE_HOTEL_PROFILE_REQUEST = "CREATE_HOTEL_PROFILE_REQUEST";
export const CREATE_HOTEL_PROFILE_SUCCESS = "CREATE_HOTEL_PROFILE_SUCCESS";
export const CREATE_HOTEL_PROFILE_FAILED = "CREATE_HOTEL_PROFILE_FAILED";

export const UPDATE_HOTEL_PROFILE_REQUEST = "UPDATE_HOTEL_PROFILE_REQUEST";
export const UPDATE_HOTEL_PROFILE_SUCCESS = "UPDATE_HOTEL_PROFILE_SUCCESS";
export const UPDATE_HOTEL_PROFILE_FAILED = "UPDATE_HOTEL_PROFILE_FAILED";

export const UPDATE_HOTEL_PROFILE_ENABLED_REQUEST = "UPDATE_HOTEL_PROFILE_ENABLED_REQUEST";
export const UPDATE_HOTEL_PROFILE_ENABLED_SUCCESS = "UPDATE_HOTEL_PROFILE_ENABLED_SUCCESS";
export const UPDATE_HOTEL_PROFILE_ENABLED_FAILED = "UPDATE_HOTEL_PROFILE_ENABLED_FAILED";

export const GET_HOTEL_LIST_PROCESS_CLEAR = "GET_HOTEL_LIST_PROCESS_CLEAR";

export type HotelListItem = {
    id: string;
    code: string;
    name: string;
    active?: boolean;
};

export type HotelProfileData = {
    id: string;
    code: string;
    name: string;
    active: boolean;
};

export type HotelProfileCreatePayload = {
    code: string;
    name: string;
    active: boolean;
};

export type HotelProfileUpdatePayload = {
    id: string;
    code: string;
    name: string;
    active: boolean;
};

export type HotelProfileEnabledUpdatePayload = {
    id: string;
    active: boolean;
};

export type GetHotelProfilePayload = {
    id: string;
};

export type GetHotelListRequest = {
    type: typeof GET_HOTEL_LIST_REQUEST;
};

export type GetHotelListSuccess = {
    type: typeof GET_HOTEL_LIST_SUCCESS;
    payload: HotelListItem[];
};

export type GetHotelListFailed = {
    type: typeof GET_HOTEL_LIST_FAILED;
    payload: string;
};

export type GetHotelProfileRequest = {
    type: typeof GET_HOTEL_PROFILE_REQUEST;
    payload: GetHotelProfilePayload;
};

export type GetHotelProfileSuccess = {
    type: typeof GET_HOTEL_PROFILE_SUCCESS;
    payload: HotelProfileData;
};

export type GetHotelProfileFailed = {
    type: typeof GET_HOTEL_PROFILE_FAILED;
    payload: string;
};

export type CreateHotelProfileRequest = {
    type: typeof CREATE_HOTEL_PROFILE_REQUEST;
    payload: HotelProfileCreatePayload;
};

export type CreateHotelProfileSuccess = {
    type: typeof CREATE_HOTEL_PROFILE_SUCCESS;
};

export type CreateHotelProfileFailed = {
    type: typeof CREATE_HOTEL_PROFILE_FAILED;
    payload: string;
};

export type UpdateHotelProfileRequest = {
    type: typeof UPDATE_HOTEL_PROFILE_REQUEST;
    payload: HotelProfileUpdatePayload;
};

export type UpdateHotelProfileSuccess = {
    type: typeof UPDATE_HOTEL_PROFILE_SUCCESS;
};

export type UpdateHotelProfileFailed = {
    type: typeof UPDATE_HOTEL_PROFILE_FAILED;
    payload: string;
};

export type UpdateHotelProfileEnabledRequest = {
    type: typeof UPDATE_HOTEL_PROFILE_ENABLED_REQUEST;
    payload: HotelProfileEnabledUpdatePayload;
};

export type UpdateHotelProfileEnabledSuccess = {
    type: typeof UPDATE_HOTEL_PROFILE_ENABLED_SUCCESS;
};

export type UpdateHotelProfileEnabledFailed = {
    type: typeof UPDATE_HOTEL_PROFILE_ENABLED_FAILED;
    payload: {
        id: string;
        message: string;
    }
};

export type GetHotelListProcessClear = {
    type: typeof GET_HOTEL_LIST_PROCESS_CLEAR;
}

export type HotelListAction = 
    | GetHotelListRequest
    | GetHotelListSuccess
    | GetHotelListFailed
    | GetHotelProfileRequest
    | GetHotelProfileSuccess
    | GetHotelProfileFailed
    | CreateHotelProfileRequest
    | CreateHotelProfileSuccess
    | CreateHotelProfileFailed
    | UpdateHotelProfileRequest
    | UpdateHotelProfileSuccess
    | UpdateHotelProfileFailed
    | UpdateHotelProfileEnabledRequest
    | UpdateHotelProfileEnabledSuccess
    | UpdateHotelProfileEnabledFailed
    | GetHotelListProcessClear;
